import type { ConversationThread } from "@redotech/effect-api-shared/models/shopper-ai/conversation/thread";
import { memo } from "react";
import { ChatThreadView } from "./chat-thread-view";

interface TiktokThreadViewProps {
  thread: ConversationThread;
}

export const TiktokThreadView = memo(function TiktokThreadView({
  thread,
}: TiktokThreadViewProps) {
  return <ChatThreadView channel="tiktok" thread={thread} />;
});
